import FlightType from './FlightType';
export default FlightType;
